module.exports = __webpack_public_path__ + "img/Icon-tree-user-vitamins.f916daa8.svg";